const name = 'SpinOut';
const properties = {
    groups: ['exit', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        cycles: {
            type: 'number',
            min: 0,
            default: 5,
        },
        direction: {
            type: 'string',
            enum: ['cw', 'ccw'],
            default: 'cw',
        },
        power: {
            type: 'string',
            enum: ['soft', 'medium', 'hard'],
            default: 'hard',
        },
    },
};
const paramsMap = {
    cw: { direction: -1 },
    ccw: { direction: 1 },
};
const scaleMap = {
    soft: 0.8,
    medium: 0.5,
    hard: 0,
};
/**
 * SpinIn animation object
 */
function animate(kit, elements, duration, delay, { direction = properties.schema.direction.default, cycles = properties.schema.cycles.default, power = properties.schema.power.default, ...params } = {}) {
    const scale = scaleMap[power];
    const fromParams = paramsMap[direction];
    const transformRotate = (fromParams.direction > 0 ? '+=' : '-=') + 360 * cycles; // eslint-disable-line no-mixed-operators
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', elements, duration, delay, {
            from: { opacity: 1 },
            to: { autoAlpha: 0 },
            ease: 'Sine.easeIn',
        }),
        kit.animate('BaseScale', elements, duration, delay, {
            to: { scale },
            ease: 'Sine.easeIn',
        }),
        kit.animate('BaseRotate', elements, duration, delay, {
            to: { rotation: transformRotate },
            ease: 'Sine.easeOut',
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=spinOut.js.map